import { Box, Theme } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { onboardingQuizPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import { TrustpilotMicroCombo } from "@outschool/ui-components-website";
import { Container } from "@outschool/ui-legacy-component-library";
import { useIsMobile, useNavigation } from "@outschool/ui-utils";
import React from "react";

import { DefaultValueProps } from "../DefaultValueProps";
import {
  DesktopCategoryHero,
  DesktopHeroImage,
  DesktopHeroTitle,
  MobileCategoryHero,
  MobileHeroTitle,
} from "../HeroComponents";

export const BasicHeroSectionTreatment: React.FC<{
  title: string;
  imageUrl: string;
  Breadcrumbs: React.ReactNode | null;
  isTutoringCLP?: boolean;
  HeroFilters?: React.ReactNode;
}> = ({
  title,
  imageUrl,
  Breadcrumbs,
  isTutoringCLP = false,
  HeroFilters = <></>,
}) => {
  const isMobile = useIsMobile();
  const { isLoggedIn } = useSession();
  const navigate = useNavigation();
  const { t } = useTranslation(
    "client\\components\\categories\\basic\\BasicHeroSectionTreatment",
  );

  if (isMobile) {
    return (
      <MobileCategoryHero
        Breadcrumbs={Breadcrumbs}
        HeroContent={
          <Box>
            <Container>
              <MobileHeroTitle title={title} />
              <DefaultValueProps />
            </Container>

            {!isTutoringCLP && (
              <Container>
                <TrustpilotMicroCombo />
              </Container>
            )}
            {!isLoggedIn && (
              <Container>
                <TrackedButton
                  trackingName="logged-out-clp-hero-button-onboarding-quiz"
                  variant="contained"
                  sx={(theme: Theme) => ({
                    [theme.breakpoints.up("md")]: {
                      alignSelf: "start",
                    },
                  })}
                  onClick={() =>
                    navigate(onboardingQuizPath(), { hardNav: true })
                  }
                >
                  {t("Get Started")}
                </TrackedButton>
              </Container>
            )}
          </Box>
        }
        isTutoringCLP={isTutoringCLP}
      />
    );
  }

  return (
    <DesktopCategoryHero
      Breadcrumbs={Breadcrumbs ?? <></>}
      HeroTitle={<DesktopHeroTitle title={title} />}
      HeroImage={!isTutoringCLP && <DesktopHeroImage imageUrl={imageUrl} />}
      isTutoringCLP={isTutoringCLP}
      HeroFilters={HeroFilters}
      HeroContent={
        <Box>
          <DefaultValueProps />
          <Box
            sx={(theme: Theme) => ({
              paddingTop: theme.spacing(16),
            })}
          >
            {!isTutoringCLP && <TrustpilotMicroCombo />}
          </Box>
          <Box
            sx={(theme: Theme) => ({
              paddingTop: theme.spacing(10),
            })}
          >
            {!isLoggedIn && (
              <TrackedButton
                trackingName="logged-out-clp-hero-button-onboarding-quiz"
                variant="contained"
                sx={(theme: Theme) => ({
                  [theme.breakpoints.up("md")]: {
                    alignSelf: "start",
                  },
                })}
                onClick={() =>
                  navigate(onboardingQuizPath(), { hardNav: true })
                }
              >
                {t("Get Started")}
              </TrackedButton>
            )}
          </Box>
        </Box>
      }
    />
  );
};
